import PropTypes from 'prop-types';
import UserDetail from "components/ui/UserDetail/UserDetail";
import "pages/MessageBox/ConversationTeaser.scss";

function ConversationTeaser({ created, profile, unreadCount, isActive, onClick }) {
  return (
    <div className={ `conversation-teaser ${ isActive ? 'conversation-teaser--active' : '' }` } onClick={ onClick }>
      <div className={ 'conversation-teaser__user' }>
        <UserDetail username={ profile?.title?.value }
                    image={ profile?.field_profile_photo?.value }/>
      </div>

      <div className={ 'conversation-teaser__date' }>
        <div>
          { created }
        </div>

        {
          unreadCount > 0 &&
          <div className={ 'conversation-teaser__counter' }>
            { unreadCount }
          </div>
        }
      </div>
    </div>
  );
}

ConversationTeaser.propTypes = {
  created: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  unreadCount: PropTypes.number.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}


export default ConversationTeaser;
